import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mea-millionare-app',
  templateUrl: './millionare-app.component.html',
  styleUrls: ['./millionare-app.component.css']
})
export class MillionareAppComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
